export default __webpack_public_path__ + "static/dot-grid-d06c03c1edd7d01c758376b206cdcefc.svg";